import { AppName, type CityPageViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the city page.
 */
export const useCityPageModelData = (): CityPageViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.City) {
    throw new Error("useCityPageModelData must be used on the city page only");
  }
  return data;
};
